var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),_vm._l((_vm.t_data),function(item){return _c('div',{staticClass:"poster"},[(item.imgUrl)?_c('img',{staticClass:"i",attrs:{"src":item.imgUrl}}):_vm._e()])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }